import { useEffect, useState } from 'react';
import { tmdb } from '../lib/tmdb.js';
import PosterCard from './PosterCard.jsx';

// A single "Because you loved [Title]" rail. Pulls recommendations for ONE
// seed so the user can see the algorithm's reasoning per loved film.
export default function BecauseYouLovedShelf({ seed, seedTitle, providerIds, onPosterClick }) {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!seed) return;
    let alive = true;
    setLoading(true);
    const seedId = `${seed.media_type}:${seed.tmdb_id || seed.id}`;
    tmdb.recommendations({ seedId, providers: providerIds })
      .then((d) => alive && setResults(d.results || []))
      .catch(() => alive && setResults([]))
      .finally(() => alive && setLoading(false));
    return () => { alive = false; };
  }, [seed?.tmdb_id, seed?.media_type, providerIds]);

  if (!loading && results.length === 0) return null;

  return (
    <section className="hb-shelf">
      <div className="hb-shelf__sign">
        <h2 className="hb-shelf__title">Because you loved {seedTitle}</h2>
      </div>
      <div className="hb-shelf__rail">
        {loading
          ? Array.from({ length: 6 }).map((_, i) => <div key={i} className="hb-poster hb-poster--skeleton" />)
          : results.map((m) => (
              <PosterCard key={`${m.media_type}:${m.id}`} movie={m} onClick={() => onPosterClick?.(m)} />
            ))
        }
      </div>
    </section>
  );
}
